import FollowMeUtils from '../FollowMeUtils';

export default class Dot {
  constructor(latitude, longitude, event) {
    this._latitude = latitude;
    this._longitude = longitude;
    this._event = event;
    this._marker = null;
    this._markerEvent = null;
  }

  setLatitude(latitude) {
    this._latitude = latitude;
    this._updateInheritedFields(this._event);
  }

  setLongitude(longitude) {
    this._longitude = longitude;
    this._updateInheritedFields(this._event);
  }

  setEvent(event) {
    this._updateInheritedFields(event);
    this._event = event;
    window.followmeMap.buildDotTable();
  }

  setEventFromTable(event) {
    this._updateInheritedFields(event);
    this._event = event;
  }

  setMarker(marker) {
    this._marker = marker;
  }

  setMarkerEvent(markerEvent) {
    this._markerEvent = markerEvent;
  }

  getLatitude() {
    return this._latitude;
  }

  getLongitude() {
    return this._longitude;
  }

  getCoordinate() {
    // eslint-disable-next-line no-undef
    return new IWCoordinate(this._longitude, this._latitude, IWCoordinate.WGS84);
  }

  getEvent() {
    return this._event;
  }

  getMarker() {
    return this._marker;
  }

  getMarkerEvent() {
    return this._markerEvent;
  }

  getHash() {
    return FollowMeUtils.hashString(this._latitude.toString() +
      this._longitude.toString() +
      JSON.stringify(this._event));
  }

  isDrawable() {
    return typeof this._event === 'undefined' || this._event.constructor.name !== 'EventCustomDefinition';
  }

  hasEvent() {
    return typeof this._event !== 'undefined';
  }

  hasMarkerEvent() {
    return this._markerEvent !== null && typeof this._markerEvent !== 'undefined';
  }

  hasMarker() {
    return this._marker !== null && typeof this._marker !== 'undefined';
  }

  clearEvent() {
    this._event = undefined;
  }

  clearMarker() {
    this._marker = null;
  }

  clearMarkerEvent() {
    this._markerEvent = null;
  }

  _updateInheritedFields(event) {
    if (!event || event.constructor.name !== 'EventCustom') return;
    const content = event.getContent();

    // eslint-disable-next-line no-restricted-syntax
    for (const item in content) {
      // eslint-disable-next-line no-continue
      if (!(item in content)) continue;

      if (['latitude', 'lat'].indexOf(item.toLowerCase()) !== -1) content[item] = this.getLatitude();
      if (['longitude', 'long', 'lng', 'lon'].indexOf(item.toLowerCase()) !== -1) content[item] = this.getLongitude();
    }
  }
}

module.exports = Dot;
